import { WbTable } from '@agilelab/plugin-wb-platform';
import { FC, useCallback, useEffect } from 'react';
import { useReleaseDetailPageContext } from '../../context/useReleaseDetailPageContext';
import { useComponentsTableColumns } from '../../hooks/useComponentsTableColumns';
import { ComponentWithStatus } from '../../types';

export const ComponentsTable: FC = () => {
  const {
    fetchReleaseDescriptor,
    components,
    currentDescriptor,
    isPartialProvisioningEnabled,
    selectAllComponents,
    setSelection,
  } = useReleaseDetailPageContext();
  const columns = useComponentsTableColumns();

  useEffect(() => {
    fetchReleaseDescriptor();
  }, [fetchReleaseDescriptor]);

  const loading = currentDescriptor === '';

  const selectedComponents = components.filter(c => c.selected);

  const handleSetSelectedItems = useCallback(
    (newSelection: ComponentWithStatus[]) => {
      if (newSelection.length === 0) {
        selectAllComponents(false);
      } else if (newSelection.length === components.length) {
        selectAllComponents(true);
      } else {
        const prevSelectedIds = new Set(
          components.filter(c => c.selected).map(c => c.id),
        );
        const newSelectedIds = new Set(newSelection.map(c => c.id));

        // Find the single item that changed
        const added = newSelection.find(c => !prevSelectedIds.has(c.id));
        if (added) {
          setSelection(added, true);
          return;
        }
        const removed = components
          .filter(c => c.selected)
          .find(c => !newSelectedIds.has(c.id));
        if (removed) {
          setSelection(removed, false);
        }
      }
    },
    [components, selectAllComponents, setSelection],
  );

  return (
    <WbTable<ComponentWithStatus>
      stickyHeader
      selection={isPartialProvisioningEnabled ? 'multiple' : undefined}
      selectedItems={selectedComponents}
      setSelectedItems={handleSetSelectedItems}
      components={{
        tableLoader: {
          loading,
        },
        tableContent: {
          columns,
          getRowId: c => c.id,
          rows: components,
        },
      }}
    />
  );
};
